import { DropkiqUI } from "./DropkiqUI";

export class DropkiqUIFromScope {
  public element: any;
  public schema: object;
  public context: object;
  public scope: object;
  public licenseKey: string;
  public options: object;
  private dropkiqEngineFromScope: any;

  private constructor(
    element: any,
    scope: object,
    schema: object,
    context: object,
    licenseKey: string,
    options: object,
    dropkiqEngineFromScope: any
  ) {
    this.element = element;
    this.scope = scope;
    this.schema = schema;
    this.context = context;
    this.licenseKey = licenseKey;
    this.options = options;
    this.dropkiqEngineFromScope = dropkiqEngineFromScope;
  }

  static async init(element: any, scope: object, licenseKey = "", options: object = {}): Promise<DropkiqUIFromScope> {
    const { DropkiqEngineFromScope } = await import("@/lib/dropkiq/dropkiq-bundle.es.js");

    const dropkiqEngineFromScope = new DropkiqEngineFromScope("", 0, scope, licenseKey, options);

    const schema = dropkiqEngineFromScope.schema;
    const context = dropkiqEngineFromScope.context;

    return new DropkiqUIFromScope(element, scope, schema, context, licenseKey, options, dropkiqEngineFromScope);
  }

  public async dropkiqUI(): Promise<DropkiqUI> {
    const instance = new DropkiqUI(this.element, this.schema, this.context, this.scope, this.licenseKey, this.options);

    instance.enable();
    return instance;
  }
}
